export default __webpack_public_path__ + "static/media/my-profile.d7810e58.svg";